/**
 * @function modifyGoodDataFilterContext
 *
 * This function is used to tell GoodData to change the filter context.  Used for applying filters to
 * the dashboard despite the fact we dont own or control them
 *
 * @param {string} name - The given name of the iframe that houses the GoodData dashboard that you want to
 * post a message to
 * @param {"auth.refresh" | "dashboard.edit" | "tab.print" | "dashboard.schedule"} message - These are the messages you can post.
 * auth.refresh - refreshes a user's token.
 * dashboard.edit - puts the dashboard into edit mode
 * tab.print - prints the current tab
 * dashboard.schedule - schedule email updates to clients.
 *
 * @return {void}
 *
 * @example
 *
 *         postGoodDataMessage(YOUR_EDU_VS_NETWORK_DASHBOARD_NAME, "auth.refresh")
 */
export const postGoodDataMessage = (
  name: string,
  message:
    | "auth.refresh"
    | "dashboard.edit"
    | "tab.print"
    | "dashboard.schedule"
) => {
  const iframe = document.getElementById(name) as HTMLIFrameElement;
  const dashboardWindow = iframe.contentWindow;
  dashboardWindow.postMessage(JSON.stringify({ gdc: { name: message } }), "*");
};
